import { SettingConst } from '@faire/web-api--source/types';

/**
 * The time in milliseconds that a user can hover over a brand link before we start speculating
 */
export const LIBP_PREFETCHING_SPECULATION_HOVER_THRESHOLD =
  'LIBP_PREFETCHING_SPECULATION_HOVER_THRESHOLD' as SettingConst<
    'LIBP_PREFETCHING_SPECULATION_HOVER_THRESHOLD',
    number,
    'RETAILER' | 'VISITOR_WEB'
  >;
